(() => {
  const shared = window.czPdpShared;
  if (shared?.config.kind !== 'rylan') return;
  const suffix = (ending) => [...document.querySelectorAll('#content > .container > .shopify-section[id]')]
    .find((section) => section.id.endsWith(ending));

  function mountPage() {
    const main = suffix('__main');
    if (!main || main.dataset.czPdpChaptersMounted) return;
    const chapters = shared.mountChapters(main);
    if (!chapters) return;
    const place = (ending, chapter) => {
      const section = suffix(ending);
      if (section && chapter) chapter.append(section);
    };
    place('__shine_pages_faq_3_variant_1_9XYUBG', chapters.meet);
    // The rod-length copy already exists in the native Length guide. Keep its
    // source block only until that guide has been copied by the option adapter.
    suffix('__custom_content_imrrQy')?.remove();
    place('__custom_content_7aJ7TT', chapters.meet);
    const originalTools = suffix('__multi_column_whmHDq');
    const toolNav = document.createElement('nav');
    toolNav.className = 'cz-pdp-tool-links';
    toolNav.setAttribute('aria-label', 'Rylan planning tools');
    originalTools?.querySelectorAll('.column.text-column').forEach((card) => {
      const label = card.querySelector('.text-column__title')?.textContent.trim();
      const link = card.querySelector('a.text-column__button');
      if (!link || !['Pleat & Stack Width', 'Curtain Weight'].includes(label)) return;
      const compact = document.createElement('a');
      compact.href = link.href;
      compact.textContent = label;
      toolNav.append(compact);
    });
    if (toolNav.childElementCount) {
      const heading = document.createElement('h2');
      heading.textContent = 'Helpful tools';
      chapters.tools.append(heading, toolNav);
    } else chapters.tools.remove();
    originalTools?.remove();
    const oldStory = suffix('__custom_content_iMVB74');
    const feature = chapters.meet.querySelector('#sp-question_item_GTd7Ld, .sp-question_item_GTd7Ld');
    const storyCopy = feature?.querySelector('.sp-question-content, .sp-question-answer, .sp-question_item-content')?.textContent.trim()
      || feature?.innerText.replace(/Decorative Rod & Discreet Motor/, '').trim();
    if (storyCopy) {
      const image = document.querySelector('.product-info .main-image img');
      const story = document.createElement('div');
      story.className = 'cz-pdp-story';
      const picture = document.createElement('img');
      if (image?.src) { picture.src = image.src; picture.alt = image.alt || 'Rylan motorized curtain rod'; picture.loading = 'lazy'; }
      const copy = document.createElement('div');
      const heading = document.createElement('h2');
      heading.textContent = 'Decorative rod & discreet motor';
      const paragraph = document.createElement('p');
      paragraph.textContent = storyCopy;
      copy.append(heading, paragraph);
      if (picture.src) story.append(picture);
      story.append(copy);
      chapters.story.append(story);
      feature.remove();
    } else chapters.story.remove();
    oldStory?.remove();
    place('__17173850389b39c4a3', chapters.reviews);
    const productFaq = suffix('__rylan_faqs');
    if (productFaq && chapters.reviews) chapters.reviews.before(productFaq);
    const consultation = [...document.querySelectorAll('a[href="/products/complimentary-1-on-1-zoom-consultation"]')]
      .find((link) => /Zoom Consultation/i.test(link.textContent));
    if (consultation) {
      const link = document.createElement('a');
      link.href = consultation.getAttribute('href');
      link.className = 'cz-pdp-consultation';
      link.textContent = 'Book a free Zoom consultation →';
      const intro = document.createElement('p');
      intro.textContent = 'Need help planning your Rylan rod? Our team can help.';
      chapters.support.append(intro, link);
      consultation.closest('.shopify-section')?.remove();
    } else chapters.support.remove();
    suffix('__custom_content_HjnmM3')?.remove();
  }

  function mountInformation() {
    const chapter = document.getElementById('cz-rylan-chapter-information');
    const tab = document.querySelector('ymq-tab[ymq-tab-product-id="12551282295102"]');
    if (!chapter || !tab || chapter.querySelector('.cz-pdp-info')) return false;
    const titles = [...tab.querySelectorAll('.ymq-tabs-li')].map((node) => node.textContent.trim());
    const contents = [...tab.querySelectorAll('.ymq-tab-content-item')];
    if (titles.length !== 5 || contents.length !== titles.length) return false;
    contents.forEach((content) => {
      content.hidden = false;
      content.style.removeProperty('display');
      content.classList.remove('ymq-tab-content-item', 'ymq-tab-content-item-active');
      content.classList.add('cz-info-panel');
      content.removeAttribute('role');
      content.removeAttribute('aria-hidden');
      content.removeAttribute('aria-expanded');
      content.removeAttribute('aria-labelledby');
    });
    const info = shared.details(contents, titles);
    info.classList.add('cz-product-info');
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'cz-product-info-trigger';
    trigger.textContent = 'Product details & guides ›';
    trigger.setAttribute('aria-haspopup', 'dialog');
    const dialog = document.createElement('dialog');
    dialog.className = 'cz-rylan-help-dialog cz-rylan-info-dialog';
    dialog.setAttribute('aria-label', 'Rylan product details and guides');
    dialog.id = 'cz-rylan-info-dialog';
    trigger.setAttribute('aria-controls', dialog.id);
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'cz-rylan-help-close';
    close.setAttribute('aria-label', 'Close product details');
    close.textContent = '×';
    const header = document.createElement('header');
    const title = document.createElement('strong');
    title.textContent = 'Product details & guides';
    header.append(title, close);
    dialog.append(header, info);
    document.body.append(dialog);
    shared.bindDialog(dialog, close, [{button: trigger}]);
    const form = suffix('__main')?.querySelector('.product-form[data-product-id="12551282295102"]');
    (form?.querySelector('.certifications-wrapper') || form?.querySelector('.quantity-submit-row'))?.before(trigger);
    chapter.remove();
    tab.hidden = true;
    return true;
  }

  const start = () => {
    mountPage();
    if (mountInformation()) return;
    const observer = new MutationObserver(() => { if (mountInformation()) observer.disconnect(); });
    observer.observe(document.getElementById('content') || document.body, {childList: true, subtree: true});
    window.addEventListener('load', () => { if (mountInformation()) observer.disconnect(); }, {once: true});
    setTimeout(() => observer.disconnect(), 10000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
